import { t } from "ttag";

import { Heading } from "@/shared/ui";

export const NextSteps = () => {
  const steps = [
    {
      title: t`Physician Review`,
      description: t`You're already pre-qualified. After checkout, a board-certified physician will review your information and begin the approval process.`,
    },
    {
      title: t`Fast Prescription Approval`,
      description: t`Most prescriptions are approved in less than 24 hours. If needed, same-day consultations with a licensed clinician are available at no extra charge.`,
    },
    {
      title: t`Medication Shipping`,
      description: t`Once approved, your medication is prepared and shipped. You'll receive tracking info within 2 business days, and your prescription will be on its way.`,
    },
    {
      title: t`Monthly Refills`,
      description: t`At the end of each month, you'll fill out a quick refill form. We'll send email and text updates with tracking info as your next shipment heads your way.`,
    },
    {
      title: t`Unlimited Support`,
      description: t`Have questions about your progress, side effects, or dosage? You'll have unlimited, 24/7 access to our care team and licensed clinicians whenever you need us.`,
    },
  ];

  return (
    <section className="flex flex-col gap-4 rounded-2xl bg-secondary-50 p-5">
      <Heading
        level={2}
        color="primary"
        size="large"
        align="center"
        weight="medium"
      >
        {t`What happens next?`}
      </Heading>

      <div className="flex flex-col gap-4 border-l-4 border-secondary-500 pl-4 text-lg">
        {steps.map(({ title, description }, i) => (
          <Step
            key={title}
            index={i + 1}
            title={title}
            description={description}
          />
        ))}
      </div>
    </section>
  );
};

interface StepProps {
  index: number;
  title: string;
  description: string;
}

const Step = ({ index, title, description }: StepProps) => (
  <div>
    <p className="font-medium text-secondary-500 uppercase">
      {t`Step`} {index}
    </p>

    <p className="font-semibold text-primary-950">{title}</p>

    <p className="text-primary-950">{description}</p>
  </div>
);
